import type { NumberSpeller } from './types'

// Assamese has an irregular word for every number 0–99.
const ONES = [
  'শূন্য', 'এক', 'দুই', 'তিনি', 'চাৰি', 'পাঁচ', 'ছয়', 'সাত', 'আঠ', 'ন',
  'দহ', 'এঘাৰ', 'বাৰ', 'তেৰ', 'চৈধ্য', 'পোন্ধৰ', 'ষোল্ল', 'সোতৰ', 'ওঠৰ', 'ঊনৈশ',
  'বিশ', 'একৈশ', 'বাইশ', 'তেইশ', 'চৌবিশ', 'পঁচিশ', 'ছাব্বিশ', 'সাতাইশ', 'আঠাইশ', 'ঊনত্ৰিশ',
  'ত্ৰিশ', 'একত্ৰিশ', 'বত্ৰিশ', 'তেত্ৰিশ', 'চৌত্ৰিশ', 'পঁয়ত্ৰিশ', 'ছয়ত্ৰিশ', 'সাতত্ৰিশ', 'আঠত্ৰিশ', 'ঊনচল্লিশ',
  'চল্লিশ', 'একচল্লিশ', 'বিয়াল্লিশ', 'তিয়াল্লিশ', 'চৌৱাল্লিশ', 'পঁয়তাল্লিশ', 'ছয়চল্লিশ', 'সাতচল্লিশ', 'আঠচল্লিশ', 'ঊনপঞ্চাশ',
  'পঞ্চাশ', 'একাৱন', 'বাৱন', 'তিপ্পন্ন', 'চৌৱন', 'পঞ্চান্ন', 'ছাপ্পন্ন', 'সাতাৱন', 'আঠাৱন', 'ঊনষাঠি',
  'ষাঠি', 'একষষ্ঠি', 'বাষষ্ঠি', 'তেষষ্ঠি', 'চৌষষ্ঠি', 'পঁয়ষষ্ঠি', 'ছয়ষষ্ঠি', 'সাতষষ্ঠি', 'আঠষষ্ঠি', 'ঊনসত্তৰ',
  'সত্তৰ', 'একসত্তৰ', 'বাসত্তৰ', 'তেসত্তৰ', 'চৌসত্তৰ', 'পঁচসত্তৰ', 'ছয়সত্তৰ', 'সাতসত্তৰ', 'আঠসত্তৰ', 'ঊনআশী',
  'আশী', 'একাশী', 'বিৰাশী', 'তিৰাশী', 'চৌৰাশী', 'পঁচাশী', 'ছিয়াশী', 'সাতাশী', 'অষ্টাশী', 'ঊননব্বৈ',
  'নব্বৈ', 'একানব্বৈ', 'বিৰানব্বৈ', 'তিৰানব্বৈ', 'চৌৰানব্বৈ', 'পঁচানব্বৈ', 'ছয়ানব্বৈ', 'সাতানব্বৈ', 'আঠানব্বৈ', 'নিৰানব্বৈ'
]
// "এশ", "দুশ", … "নশ"; beyond nine: "ঊনৈশ শ".
const HUNDREDS = ['', 'এশ', 'দুশ', 'তিনিশ', 'চাৰিশ', 'পাঁচশ', 'ছশ', 'সাতশ', 'আঠশ', 'নশ']

function hundreds(h: number): string {
  return h < 10 ? HUNDREDS[h] : `${ONES[h]} শ`
}

function withHundreds(h: number, r: number): string {
  return [h ? hundreds(h) : '', r ? ONES[r] : ''].filter(Boolean).join(' ')
}

function spell(n: number): string {
  if (n === 0) return ONES[0]
  const parts: string[] = []
  const units: Array<[number, string]> = [[10_000_000, 'কোটি'], [100_000, 'লাখ'], [1000, 'হাজাৰ']]
  let rest = n
  for (const [size, word] of units) {
    const q = Math.floor(rest / size)
    if (q) parts.push(`${spell(q)} ${word}`)
    rest %= size
  }
  if (rest) parts.push(withHundreds(Math.floor(rest / 100), rest % 100))
  return parts.join(' ')
}

export const asm: NumberSpeller = {
  spell,
  // 2000–2099: "দুই হাজাৰ ছাব্বিশ"; 1100–1999: "ঊনৈশ শ পঁচাশী".
  year: (n) => (n >= 1100 && n < 2000 ? withHundreds(Math.floor(n / 100), n % 100) : spell(n)),
  rupees: 'টকা'
}
